import React, { ReactElement } from 'react';

const MomentiveLogoMark = (): ReactElement => {
  return (
    <svg
      viewBox="0 0 36 24"
      data-testid="MomentiveLogoMark"
      width={36}
      height={24}
    >
      <g
        id="MomentiveLogoMarkGroup1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="MomentiveLogoMarkGroup2"
          transform="translate(-0.000000, 0.000000)"
        >
          <path
            d="M19.137,11.242 C21.576,14.893 23,19.28 23,24 L36,24 L36,0 L19.137,11.242"
            id="MomentiveLogoMarkFill11"
            fill="#2CB2F1"
          />
          <path
            d="M0,1 L0,24 L19.137,11.242 C15.0125,5.068 7.9825,1 0,1"
            id="MomentiveLogoMarkFill12"
            fill="#FFE11B"
          />
          <path
            d="M0,24 L23,24 C23,19.28 21.576,14.893 19.137,11.242 L0,24"
            id="MomentiveLogoMarkFill13"
            fill="#008323"
          />
        </g>
      </g>
    </svg>
  );
};

export default MomentiveLogoMark;
